import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { LdapDirectoryType } from '../../../services/enums/ldap';
import { Toggle } from '@checkmarx/cx-ui';
import PortalTextBox from '../../portal/portalTextBox';
import PortalCheckBox from '../../portal/controls/checkbox';
import PortalDropdown from '../../portal/portalDropdown';
import DomainsDropdownContainer from './domainsDropdownContainer';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';
import {
    EnableSSOTooltip, DirectoryTypeTooltip, BaseDnTooltip,
    AdditionalUserDnTooltip, UserObjectSchemaTooltip, UserObjectFilterTooltip,
    UserNameAttributeTooltip,
    UserFirstNameAttributeTooltip, UserLastNameAttributeTooltip, UserEmailAttributeTooltip
} from './ldapHelpTooltipContent';

@inject('translationsStore') @observer
export default class LdapSchemaForm extends Component {

    currentLdapStore = this.props.currentLdapStore;
    ldapValidator = this.props.ldapValidator;

    onChangeHandleDirectoryType = (e, index, value) => {

        this.currentLdapStore.setLdapDirectoryType(value);
        this.ldapValidator.validateDirectoryType(this.currentLdapStore.ldapDirectoryType);

        switch (value) {
            case LdapDirectoryType.activeDirectory:
                this.setActiveDirectoryDefaults();
                break;
            case LdapDirectoryType.openLDAP:
                this.setOpenLdapDefaults();
                this.resetDirectoryType();
                break;
            case LdapDirectoryType.customLDAPServer:
                this.setCustomLdapServer();
                this.resetDirectoryType();
                break;
            default:
                this.resetDirectoryType();
        }
    }

    onChangeEnableSSO = () => {

        this.currentLdapStore.setSsoEnabled(!this.currentLdapStore.ssoEnabled);
        if (!this.currentLdapStore.ssoEnabled) {
            this.currentLdapStore.setMappedDomainId(-1);
            this.ldapValidator.validateMapLdapTo(this.currentLdapStore.ssoEnabled, this.currentLdapStore.mappedDomainId);
        }
    }

    onChangeMappedDomain = (e, index, value) => {

        this.currentLdapStore.setMappedDomainId(value);
        this.ldapValidator.validateMapLdapTo(this.currentLdapStore.ssoEnabled, this.currentLdapStore.mappedDomainId);
    }

    onChangeBaseDn = e => this.currentLdapStore.setBaseDn(e.target.value);
    onBlurBaseDn = e => {
        this.currentLdapStore.setBaseDn(e.target.value.trim());
        this.ldapValidator.validateBaseDn(this.currentLdapStore.baseDn);
    }

    onChangeAdditionalUserDn = e => this.currentLdapStore.setAdditionalUserDn(e.target.value);
    onBlurAdditionalUserDn = e => this.currentLdapStore.setAdditionalUserDn(e.target.value.trim());

    onChangeUserObjectClass = e => this.currentLdapStore.setUserObjectClass(e.target.value);
    oonBlurUserObjectClass = e => {
        this.currentLdapStore.setUserObjectClass(e.target.value.trim());
        this.ldapValidator.validateUserObjectSchema(this.currentLdapStore.userObjectClass);
    }

    onChangeUserObjectFilter = e => this.currentLdapStore.setUserObjectFilter(e.target.value);
    onBlurUserObjectFilter = e => {
        this.currentLdapStore.setUserObjectFilter(e.target.value.trim());
        this.ldapValidator.validateUserObjectFilter(this.currentLdapStore.userObjectFilter);
    }

    onChangeUsernameAttribute = e => this.currentLdapStore.setUsernameAttribute(e.target.value);
    onBlurUsernameAttribute = e => {
        this.currentLdapStore.setUsernameAttribute(e.target.value.trim());
        this.ldapValidator.validateUsernameAttribute(this.currentLdapStore.usernameAttribute);
    }

    onChangeFirstNameAttribute = e => this.currentLdapStore.setFirstNameAttribute(e.target.value);
    onBlurFirstNameAttribute = e => this.currentLdapStore.setFirstNameAttribute(e.target.value.trim());

    onChangeLastNameAttribute = e => this.currentLdapStore.setLastNameAttribute(e.target.value);
    onBlurLastNameAttribute = e => this.currentLdapStore.setLastNameAttribute(e.target.value.trim());

    onChangeEmailAttribute = e => this.currentLdapStore.setEmailAttribute(e.target.value);
    onBlurEmailAttribute = e => this.currentLdapStore.setEmailAttribute(e.target.value.trim());

    setActiveDirectoryDefaults = () => {

        this.currentLdapStore.setUserObjectClass('user');
        this.currentLdapStore.setUserObjectFilter('(&(objectCategory=Person)(sAMAccountName=*))');
        this.currentLdapStore.setUsernameAttribute('sAMAccountName');
        this.currentLdapStore.setFirstNameAttribute('givenName');
        this.currentLdapStore.setLastNameAttribute('sn');
        this.currentLdapStore.setEmailAttribute('mail');
    }

    setOpenLdapDefaults = () => {

        this.currentLdapStore.setUserObjectClass('inetorgperson');
        this.currentLdapStore.setUserObjectFilter('(objectclass=inetorgperson)');
        this.currentLdapStore.setUsernameAttribute('uid');
        this.currentLdapStore.setFirstNameAttribute('givenName');
        this.currentLdapStore.setLastNameAttribute('sn');
        this.currentLdapStore.setEmailAttribute('mail');
    }

    setCustomLdapServer = () => {

        this.currentLdapStore.setUserObjectClass('');
        this.currentLdapStore.setUserObjectFilter('');
        this.currentLdapStore.setUsernameAttribute('');
        this.currentLdapStore.setFirstNameAttribute('');
        this.currentLdapStore.setLastNameAttribute('');
        this.currentLdapStore.setEmailAttribute('');
    }

    resetDirectoryType() {

        this.currentLdapStore.setSsoEnabled(false);
        this.currentLdapStore.setMappedDomainId(-1);
    }

    handleChangeWildcardSearch = e => this.props.currentLdapStore.setWildcardSearch(e.target.checked);

    render() {

        const enableSSOTitle = `${this.props.translationsStore.translate('ENABLE_SSO')} ${this.props.translationsStore.translate('MAP_LDAP_TO_ACTIVE_DIRECTORY_TITLE')}`;

        return (
            <div className='ldap-schema-form-main-wrapper'>
                <div className='form-row'>
                    <PortalDropdown
                        dataCy='ddl-directory-type'
                        hintText={this.props.translationsStore.translate('DIRECTORY_TYPE')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('DIRECTORY_TYPE')}
                            required={true} />}
                        width='47%'
                        items={this.currentLdapStore.directoryTypes()}
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeHandleDirectoryType}
                        errorText={this.ldapValidator.directoryTypeValidationMessage}
                        value={this.currentLdapStore.ldapDirectoryType.toLowerCase() || 'none'}
                        helpTooltipText={<DirectoryTypeTooltip />}

                    />
                </div>
                <div className='form-row enable-sso'>
                    <PortalCheckBox
                        dataCy='cbx-enable-sso'
                        checked={true}
                        label={enableSSOTitle}
                        onCheck={this.onChangeEnableSSO}
                        checked={this.currentLdapStore.ssoEnabled}
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress ||
                            this.currentLdapStore.ldapDirectoryType.toLowerCase() != LdapDirectoryType.activeDirectory}
                        helpTooltipText={<EnableSSOTooltip />}
                    />
                </div>
                <div className='form-row'>
                    <DomainsDropdownContainer
                        dataCy='ddl-map-to'
                        hintText={this.props.translationsStore.translate('MAP_LDAP_TO')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('MAP_LDAP_TO')}
                            required={this.currentLdapStore.ssoEnabled} />}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress || !this.currentLdapStore.ssoEnabled}
                        onChange={this.onChangeMappedDomain}
                        errorText={this.ldapValidator.mapLdapToValidationMessage}
                        value={this.currentLdapStore.mappedDomainId || -1}
                    />
                </div>
                <div className='sub-title'>
                    {this.props.translationsStore.translate('LDAP_SCHEMA')}
                </div>
                <div className='form-row'>
                    <PortalTextBox
                        dataCy='txt-base-dn'
                        hintText={this.props.translationsStore.translate('BASE_DN')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('BASE_DN')}
                            required={true} />}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeBaseDn}
                        onBlur={this.onBlurBaseDn}
                        errorText={this.ldapValidator.baseDnValidationMessage}
                        value={this.currentLdapStore.baseDn || ''}
                        helpTooltipText={<BaseDnTooltip />}
                    />
                    <PortalTextBox
                        dataCy='txt-additional-user-dn'
                        hintText={this.props.translationsStore.translate('ADDITIONAL_USER_DN')}
                        floatingLabelText={this.props.translationsStore.translate('ADDITIONAL_USER_DN')}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeAdditionalUserDn}
                        onBlur={this.onBlurAdditionalUserDn}
                        errorText={this.ldapValidator.additionalUserDnValidationMessage}
                        value={this.currentLdapStore.additionalUserDn || ''}
                        helpTooltipText={<AdditionalUserDnTooltip />}
                    />
                </div>
                <div className='sub-title'>
                    {this.props.translationsStore.translate('USER_SCHEMA_SETTINGS')}
                </div>
                <div className='form-row'>
                    <PortalTextBox
                        dataCy='txt-user-object-class'
                        hintText={this.props.translationsStore.translate('USER_OBJECT_CLASS')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('USER_OBJECT_CLASS')}
                            required={true} />}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeUserObjectClass}
                        onBlur={this.oonBlurUserObjectClass}
                        errorText={this.ldapValidator.userObjectSchemaValidationMessage}
                        value={this.currentLdapStore.userObjectClass || ''}
                        helpTooltipText={<UserObjectSchemaTooltip />}
                    />
                    <PortalTextBox
                        dataCy='txt-object-filter'
                        hintText={this.props.translationsStore.translate('USER_OBJECT_FILTER')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('USER_OBJECT_FILTER')}
                            required={true} />}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeUserObjectFilter}
                        onBlur={this.onBlurUserObjectFilter}
                        errorText={this.ldapValidator.userObjectFilterValidationMessage}
                        value={this.currentLdapStore.userObjectFilter || ''}
                        helpTooltipText={<UserObjectFilterTooltip />}
                    />
                </div>
                <div className='form-row'>
                    <PortalTextBox
                        dataCy='txt-username-attribute'
                        hintText={this.props.translationsStore.translate('USER_NAME_ATTRIBUTE')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('USER_NAME_ATTRIBUTE')}
                            required={true} />}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeUsernameAttribute}
                        onBlur={this.onBlurUsernameAttribute}
                        errorText={this.ldapValidator.usernameAttributeValidationMessage}
                        value={this.currentLdapStore.usernameAttribute || ''}
                        helpTooltipText={<UserNameAttributeTooltip />}
                    />
                    <PortalTextBox
                        dataCy='txt-first-name-attribute'
                        hintText={this.props.translationsStore.translate('USER_FIRST_NAME_ATTRIBUTE')}
                        floatingLabelText={this.props.translationsStore.translate('USER_FIRST_NAME_ATTRIBUTE')}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeFirstNameAttribute}
                        onBlur={this.onBlurFirstNameAttribute}
                        errorText={this.ldapValidator.firstNameAttributeValidationMessage}
                        value={this.currentLdapStore.firstNameAttribute || ''}
                        helpTooltipText={<UserFirstNameAttributeTooltip />}
                    />
                </div>
                <div className='form-row'>
                    <PortalTextBox
                        dataCy='txt-last-name-attribute'
                        hintText={this.props.translationsStore.translate('USER_LAST_NAME_ATTRIBUTE')}
                        floatingLabelText={this.props.translationsStore.translate('USER_LAST_NAME_ATTRIBUTE')}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeLastNameAttribute}
                        onBlur={this.onBlurLastNameAttribute}
                        errorText={this.ldapValidator.lastNameAttributeValidationMessage}
                        value={this.currentLdapStore.lastNameAttribute || ''}
                        helpTooltipText={<UserLastNameAttributeTooltip />}
                    />
                    <PortalTextBox
                        dataCy='txt-email-attribute'
                        hintText={this.props.translationsStore.translate('USER_EMAIL_ATTRIBUTE')}
                        floatingLabelText={this.props.translationsStore.translate('USER_EMAIL_ATTRIBUTE')}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeEmailAttribute}
                        onBlur={this.onBlurEmailAttribute}
                        errorText={this.ldapValidator.emailAttributeValidationMessage}
                        value={this.currentLdapStore.emailAttribute || ''}
                        helpTooltipText={<UserEmailAttributeTooltip />}
                    />
                </div>
                <div className='form-row'>
                    <Toggle
                        className='enable-ldap-server'
                        icons={false}
                        onChange={this.handleChangeWildcardSearch}
                        checked={this.currentLdapStore.wildcardSearch}
                        text={this.props.translationsStore.translate('WILDCARD_FILTER_USER_OBJECT')}
                    />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ldap/forms/ldapSchemaForm.jsx